document.addEventListener('DOMContentLoaded', function() {
  let scrollPosition = 0;
  const modal = document.querySelector('.modal.modalOverview');
  const content = document.getElementById('content');
  const mainCol = document.getElementById('main-col');

  // モーダルを#content内に移動
  if (modal && content) {
    content.appendChild(modal);
  }

  function openModal() {
    scrollPosition = window.scrollTop || window.pageYOffset;
    modal.classList.add('is-active');
    mainCol.style.cssText = 'position: fixed; width: 100%; top: ' + -scrollPosition + 'px;';
  }

  function closeModal() {
    modal.classList.remove('is-active');
    mainCol.style.cssText = '';
    window.scrollTo(0, scrollPosition);
  }

  // モーダルを開く
  document.addEventListener('click', function(e) {
    if (e.target.closest('.modalBtn')) {
      e.preventDefault();
      openModal();
    }
    // 閉じる処理
    else if (e.target.classList.contains('closeModal') || e.target.closest('.closeModal')) {
      e.preventDefault();
      closeModal();
    }
    // エリア外クリック
    else if (modal.classList.contains('is-active') && e.target === modal || e.target.classList.contains('modalOverlay')) {
      closeModal();
    }
  });

  // 各カテゴリのグリッド制御
  const grids = document.querySelectorAll('.content-grid');

  grids.forEach(grid => {
    const category = grid.dataset.category;
    const items = grid.querySelectorAll('.grid-item');
    const loadMoreBtn = document.querySelector(`[data-target="${category}"]`);
    const loadMoreContainer = loadMoreBtn?.parentElement;

    if (!loadMoreBtn) return;

    // 初期表示設定
    let visibleCount = getInitialVisibleCount();
    let currentVisible = visibleCount;

    // .load-more-containerの高さを最初の.grid-itemのimgの高さに合わせる
    function setLoadMoreContainerHeight() {
      if (!loadMoreContainer) return;

      // 最初の表示されているgrid-itemのimgを見つける
      const firstVisibleItem = Array.from(items).find(item => {
        return item.style.display !== 'none';
      });

      if (firstVisibleItem) {
        const img = firstVisibleItem.querySelector('img');
        if (img && img.complete) {
          const imgHeight = img.offsetHeight;
          loadMoreContainer.style.height = imgHeight + 'px';
        }
      }
    }

    // 画像の読み込み完了後に高さを設定
    if (loadMoreContainer) {
      const images = grid.querySelectorAll('.grid-item img');
      images.forEach(img => {
        if (img.complete) {
          setLoadMoreContainerHeight();
        } else {
          img.addEventListener('load', () => {
            setLoadMoreContainerHeight();
          });
        }
      });
    }

    // 初期状態で非表示アイテムを隠す
    items.forEach((item, index) => {
      if (index >= currentVisible) {
        item.style.display = 'none';
      }
    });

    // ボタンの表示/非表示を制御
    function updateButtonVisibility() {
      if (items.length <= currentVisible) {
        loadMoreContainer.style.display = 'none';
      } else {
        loadMoreContainer.style.display = 'flex';
      }
    }

    // ボタンの状態を管理
    let isExpanded = false;
    // 「さらに読み込む」ボタンをクリックした時の位置を保存
    let expandButtonPosition = 0;

    // ボタンのテキストとアイコンを更新
    function updateButtonState() {
      const btnText = loadMoreBtn.querySelector('.btn-text');
      const btnIcon = loadMoreBtn.querySelector('.btn-icon');

      if (isExpanded) {
        btnText.textContent = '閉じる';
        // 後でバッテンアイコンに変更予定
        // btnIcon.innerHTML = '<svg>...</svg>';
      } else {
        btnText.textContent = 'さらに読み込む';
        // 現在の矢印アイコンを維持
      }
    }

    // 初期状態でボタンの表示を制御
    updateButtonVisibility();
    updateButtonState();

    // 初期化後に高さを設定
    setTimeout(() => {
      setLoadMoreContainerHeight();
    }, 100);

    // ボタンクリック時の処理
    loadMoreBtn.addEventListener('click', function() {
      if (isExpanded) {
        // 閉じる処理：初期表示数に戻す
        items.forEach((item, index) => {
          if (index >= visibleCount) {
            item.style.display = 'none';
          }
        });
        currentVisible = visibleCount;
        isExpanded = false;
        grid.classList.remove('is-expanded');

        // 保存した「さらに読み込む」ボタンの位置までスクロール
        if (expandButtonPosition > 0) {
          window.scrollTo({
            top: expandButtonPosition,
            behavior: 'smooth'
          });
        }
      } else {
        // 展開処理：全てのアイテムを表示
        // 「さらに読み込む」ボタンの位置を保存（ボタンの下端がビューポートの下部から80px上に来る位置）
        const rect = loadMoreBtn.getBoundingClientRect();
        expandButtonPosition = window.scrollY + rect.bottom - window.innerHeight + 80;

        items.forEach(item => {
          item.style.display = 'block';
        });
        currentVisible = items.length;
        isExpanded = true;
        grid.classList.add('is-expanded');
      }

      updateButtonState();
    });

    // リサイズ時の処理
    window.addEventListener('resize', function() {
      const newVisibleCount = getInitialVisibleCount();
      if (newVisibleCount !== visibleCount) {
        visibleCount = newVisibleCount;
        currentVisible = visibleCount;

        // アイテムの表示/非表示を再設定
        items.forEach((item, index) => {
          if (index >= currentVisible) {
            item.style.display = 'none';
          } else {
            item.style.display = 'block';
          }
        });

        // 状態をリセット
        isExpanded = false;
        grid.classList.remove('is-expanded');

        // ボタンの表示を再制御
        updateButtonVisibility();
        updateButtonState();
      }

      // リサイズ時にも高さを再計算
      setLoadMoreContainerHeight();
    });
  });

  function getInitialVisibleCount() {
    // PC: 3列（9個）、SP: 4列（4個）
    return window.innerWidth >= 801 ? 9 : 4;
  }
});